const isIE = () => {
    const ua = navigator.userAgent;
    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;
};

export function selectDropDown() {
    if (isIE()) {
        return;
    }

    let container = document.querySelectorAll('.select-dropdown');

    if (!container) {
        return
    }

    let choiceJs = require("choices.js"),
        reset_btn = document.querySelector('.btn__reset');

    const elements = document.querySelectorAll('.js-choice');

    elements.forEach((item) => {
        let select = new choiceJs(item, {
            searchEnabled: false,
            allowHTML: false,
            shouldSort: false,
        })

        select.passedElement.element.addEventListener(
            'change', function (event) {
                insert_cities(JSON.parse(event.detail.value))
            }, false
        );

        if(reset_btn) {
            reset_btn.addEventListener('click', function(e){
                select.removeActiveItems();
                select.setChoiceByValue("0")
            })
        }
    })
}

function insert_cities(data) {
    let cites_container = document.querySelector('.radio__container .city-selector');

    if (!cites_container) {
        return;
    }

    cites_container.innerHTML = '';
    cites_container.parentElement.classList.remove('hide__container')


    data.forEach((item, index) => {
        cites_container.innerHTML += `<input type="radio" class="sr-only city" name="kust_id" value="${index}" id="radio-${index}-${item.city}" aria-labelledby="radio-${index}-${item.city}" data-course="${JSON.stringify(item)}">
            <label for="radio-${index}-${item.city}">
            <span id="radio--${index}-${item.city}">${item.city}</span>
            </label>`;
    })

    if(data.length === 1){
        cites_container.querySelector('.city').click()
    }


}